import { computeDiscountedPrice, type Coupon } from './computeDiscountedPrice';

/**
 * Computes the amount discounted off the base price by a coupon.
 *
 * Defined as basePrice − computeDiscountedPrice(basePrice, coupon) so the two
 * stay in lockstep: anything that changes how the discounted price is
 * calculated (clamps, rounding) flows through here automatically.
 *
 * @param basePrice - The base price (in any currency unit).
 * @param coupon    - The validated coupon, or null if none.
 * @returns         The amount taken off the base price (>= 0).
 */
export function computeDiscountAmount(basePrice: number, coupon: Coupon | null): number {
  return basePrice - computeDiscountedPrice(basePrice, coupon);
}
